import { useState, useCallback } from 'react'

/**
 * Hook om Caps Lock te detecteren bij wachtwoordinvoer.
 * Retourneert capsLockOn en handlers om aan het input-veld te koppelen.
 * Toon een waarschuwing wanneer capsLockOn true is.
 */
export function useCapsLockWarning() {
  const [capsLockOn, setCapsLockOn] = useState(false)

  const onKeyDown = useCallback((e) => {
    if (e.getModifierState) {
      setCapsLockOn(e.getModifierState('CapsLock'))
    }
  }, [])

  return { capsLockOn, onKeyDown }
}
